module.exports = "<footer>\n  <div class=\"container\">\n    <div class=\"row\">\n      <div class=\"col-md-12 privacy\">\n        <a href=\"http://www.mheducation.com/privacy.html\" target=\"_blank\" translate>MHE_PRIVACY_LINK</a>\n      </div>\n    </div>\n    <div class=\"row\">\n      <div class=\"col-md-12 copyright\">\n        &copy; <span translate>FOOTER_COPYRIGHT</span>\n      </div>\n    </div>\n  </div>\n</footer>\n"


//////////////////
// WEBPACK FOOTER
// ./app/common/appFooter/appFooter.html
// module id = 214
// module chunks = 1